module.exports = angular;


//////////////////
// WEBPACK FOOTER
// external "angular"
// module id = 3
// module chunks = 0 3 4